import {
  teamsDarkV21Theme,
  teamsHighContrastTheme,
  teamsLightV21Theme,
} from '@fluentui/react-components';

export type ThemeType = 'system' | 'dark' | 'highContrast' | 'light';

// --color-fluent-primary
const PRIMARY_COLOR = 'rgb(214, 11, 81)';
const PRIMARY_COLOR_PRESSED = 'rgb(174, 9, 65)';

export const useAixFluentUiComponentsTheme = (themeType: ThemeType) => {
  let base;

  switch (themeType) {
    case 'light':
      base = teamsLightV21Theme;
      break;
    case 'dark':
      base = teamsDarkV21Theme;
      break;
    case 'highContrast':
      base = teamsHighContrastTheme;
      break;
  }

  const theme = {
    ...base,
    colorCompoundBrandBackground: PRIMARY_COLOR,
    colorCompoundBrandBackgroundHover: 'rgb(194, 0, 61)',
    colorCompoundBrandBackgroundPressed: PRIMARY_COLOR_PRESSED,
    // Existing overrides
    colorNeutralForeground2BrandHover: PRIMARY_COLOR,
    colorNeutralForeground2BrandPressed: PRIMARY_COLOR,
    // Used by MenuItem icons on hover (Fluent v9 maps hover → "Selected" here)
    colorNeutralForeground2BrandSelected: PRIMARY_COLOR,
    colorCompoundBrandStroke: PRIMARY_COLOR,
    colorCompoundBrandStrokeHover: PRIMARY_COLOR,
    colorCompoundBrandStrokePressed: PRIMARY_COLOR_PRESSED,
    colorCompoundBrandForeground1: PRIMARY_COLOR,
    colorCompoundBrandForeground1Hover: PRIMARY_COLOR,
    colorCompoundBrandForeground1Pressed: PRIMARY_COLOR_PRESSED,
    colorBrandStroke1: PRIMARY_COLOR,
    colorBrandStroke2Contrast: 'rgb(255, 184, 184)',
    // Brand foreground colors (for text in brand color)
    colorBrandForeground1: PRIMARY_COLOR,
    colorBrandForeground2: PRIMARY_COLOR,
    // Primary Button background colors
    colorBrandBackground: PRIMARY_COLOR,
    colorBrandBackgroundHover: PRIMARY_COLOR, // No hover effect - same as primary
    colorBrandBackgroundPressed: PRIMARY_COLOR_PRESSED,
    colorBrandBackgroundSelected: PRIMARY_COLOR_PRESSED,
    // Neutral foreground hover states — used by MenuItem text + icon on hover.
    // Background stays neutral; only text and icon take the brand color
    // (matches the Northstar-era hover behaviour).
    colorNeutralForeground2Hover: PRIMARY_COLOR,
    colorNeutralForeground3Hover: PRIMARY_COLOR,
    // Global Button styling tokens to match Northstar
    borderRadiusMedium: '4px',
    shadow4: '0 0.2rem 0.4rem -0.0625rem rgba(0, 0, 0, 0.25)',
    // DatePicker calendar day colors in dark mode
    ...(themeType === 'dark' && {
      colorBrandBackgroundInvertedSelected: 'rgb(68, 71, 145)',
      colorBrandBackgroundInvertedHover: 'rgb(56, 57, 102)',
    }),
  };

  return {
    theme,
  };
};
